import {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import {
  isModifying,
  removeFromTemporaryEventsList,
  temporaryEvents,
} from '../../../../../../../../../store/reducers/reviews';
import {calculateEventTop} from '../../../../../utils/edReviewUtils';
import {OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';
import {calculateTileHeight} from '../../../utils/sessionUtilities';
import DailyCalendarTile from './dailyCalendarTile/dailyCalendarTile';
import _find from 'lodash/find';

export const TemporaryLockedSlot = (
  {
    className,
    columnIndex,
    columnEvents,
  }) => {
  const dispatch = useDispatch();

  const tempEventObj = useSelector(temporaryEvents);
  const isManupulationStateModifying = useSelector(isModifying);

  const onButtonClick = useCallback((event) => {
    dispatch(removeFromTemporaryEventsList(event?.parentSession, event, false));
    }, [dispatch]);

  if (!isEmpty(Object.keys(tempEventObj))) {
    const parentSessionEventIds = Object.keys(tempEventObj);

    if (!isEmpty(parentSessionEventIds)) {
      return parentSessionEventIds.map((sessionId, sessionIdIndex) => {
        const temporaryLockedSessionList = tempEventObj?.[sessionId];
        const columnEventsHasAssignedSession = _find(columnEvents, { sessionId: sessionId }) || (isManupulationStateModifying && columnIndex === sessionId);

        if (!isEmpty(temporaryLockedSessionList)) {
          return temporaryLockedSessionList.map((session, sessionIndex) => {
            return columnEventsHasAssignedSession && (
              <DailyCalendarTile
                session
                tileSelected
                temporaryLock
                availableSlot
                event={session}
                selected={true}
                id={sessionIndex}
                className={className}
                patientAssign={false}
                columnIndex={columnIndex}
                onButtonClick={onButtonClick}
                key={`${sessionIdIndex}${sessionIndex}`}
                options={{
                  left: 0,
                  width: '100%',
                  height: calculateTileHeight(session),
                  top: calculateEventTop({
                    event: session,
                    offset: OFFSET,
                    isReview: false,
                    slotHeight: SLOT_HEIGHT,
                  }),
                }}
              />
            );
          })}})
    }
    return null;
  }  else {
    return null
  }
};

TemporaryLockedSlot.propTypes = {
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  sessionColumns: PropTypes.object,
}

TemporaryLockedSlot.propTypes = {
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  sessionColumns: PropTypes.object,
}

export default memo(TemporaryLockedSlot, _isEqual);